import React, { useEffect } from 'react'
import './achievements.css'
import Aos from 'aos'
import 'aos/dist/aos.css'
const Achievements = () => {
  useEffect(()=>{
    Aos.init({ duration:2000})
 },[])
  return (
    <div className="mmf-achievements conatiner"  data-aos="fade-up">
      
    <div className="mmf-boxes">

        <div className="mmf-supporters i-box"  data-aos="fade-right">
          <h3>5+</h3>
          <p>Number of 
          Supporters</p>
        </div>
        <div className="mmf-volunteers i-box"  data-aos="fade-right">
          <h3>90+</h3>
          <p>Volunteers Nationwide</p>
        </div>
        <div className="mmf-amount-raise i-box"  data-aos="fade-left">
          <h3>170K+</h3>
          <p>PKR We've Helped Raise</p>
        </div>
        <div className="mmf-project-funds i-box"  data-aos="fade-left">
          <h3>700+</h3>
          <p>Students Impacted</p>
        </div>


      </div>
      <div className='donate-container'  data-aos="fade-bottom">
    
      <div className='left-dc'>
      <span>Help us making lives better</span>
      <span>Empowering the Nation with Skills for a Better Future</span>
      </div>
      <div className='right-dc'>
      <a href="#" class="donate-now">DONATE NOW</a> 
      </div>
      
      </div>
    </div>
  )
}

export default Achievements
